import _util from '../../utils/';


const insuranceLedgerService = {
	selectInsuranceLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalarySalaryAccountMonthly/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	detailInsuranceLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryInsPaymentLed/Get',
			params: data,
			success: resolve,
			error: reject
		})
	},
	exportInsuranceLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HRSalaryInsPaymentLed/Export',
			params: data,
			success: resolve,
			error: reject
		})
	},
	createInsuranceLedger(data, resolve, reject) {
		_util.request({
			url: '/api/HROffersRequirement/Post',
			method: "post",
			data: data,
			success: resolve,
			error: reject
		})
	}
};


export default insuranceLedgerService;


// WEBPACK FOOTER //
// ./src/services/SalaryAllowance/insurance-ledger-service.js